// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { TimeBaseEntity } from '../time-base-entity';
import { BillDetail } from './bill-detail';
import { TimeCategory } from './time-category';
import { TimeEntryStatus } from './time-entry-status';
import { TimeEntryTax } from './time-entry-tax';
import { TimeEntryType } from './time-entry-type';
import { UserTypeRate } from './user-type-rate';

/// <code-import> Place custom imports between <code-import> tags
import { Admin, AdminType, User, UserType } from '..';
/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class TimeEntry extends TimeBaseEntity  {

  /// <code> Place custom code between <code> tags
  user: User;
  userType: UserType;
  job: Admin;
  jobType: AdminType;
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  adminId!: number;
  adminTypeId!: number;
  createdAt!: Date;
  createdBy?: string;
  entryDateTime!: Date;
  notes?: string;
  practiceId!: number;
  timeCategory1Id!: number;
  timeCategory2Id?: number;
  timeCategory3Id?: number;
  timeEntryStatusId!: number;
  timeEntryTypeId!: number;
  timeRate?: number;
  timeRateId?: number;
  timeTotal!: number;
  timeUnits?: number;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  userId!: number;
  userTypeId?: number;
  billDetails!: BillDetail[];
  timeCategory1!: TimeCategory;
  timeCategory2!: TimeCategory;
  timeCategory3!: TimeCategory;
  timeEntryStatus!: TimeEntryStatus;
  timeEntryTaxes!: TimeEntryTax[];
  timeEntryType!: TimeEntryType;
  userTypeRate!: UserTypeRate;
}

